import { z } from 'zod';
import { documentSchema } from './IDocument';

export const invoicePaidSchema = z.object({
  idInvoicePaid: z.number().default(-1),
  idInvoice: z.number().default(-1),
  idDocument: z.number().nullable().default(null),
  PaidValue: z.number().default(0),
  PaidDate: z.string().default(new Date().toISOString().split('T')[0]),
  //
  DocumentObject: documentSchema.optional(),
});
export type IInvoicePaid = z.infer<typeof invoicePaidSchema>;
